import { useMutation, useQueryClient, MutationOptions } from "react-query";
import { patch, API_URL, APIResponse, APIError } from "../api";

/**
 * Customer action: confirm a delivered item was received.
 * PATCH /commerce/orders/items/{itemId}/received (backend requires the item to be
 * in the `delivered` state first).
 */
export function useMarkOrderItemReceived(
  itemId: string,
  options?: MutationOptions<APIResponse<any>, APIError, void>
) {
  const queryClient = useQueryClient();

  const { mutate, isLoading, isError, error, data } = useMutation(
    () =>
      patch(
        `${API_URL}/commerce/orders/items/${itemId}/received`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      ),
    {
      ...options,
      onSuccess: (...args) => {
        queryClient.refetchQueries("order-item-details-" + itemId);
        options?.onSuccess?.(...args);
      },
    }
  );

  return {
    markReceived: mutate,
    markingReceived: isLoading,
    isMarkReceivedError: isError,
    markReceivedError: error,
    markReceivedResponse: data,
  };
}

export default useMarkOrderItemReceived;
